/**
 * Category Badge Component
 * Displays a badge with category icon and name
 */

import { Badge } from '../ui/Badge';
import { CategoryIcon } from './CategoryIcon';
import { cn } from '../../lib/utils';

interface CategoryBadgeProps {
  category: {
    code: string;
    displayName: string;
    icon: string;
    color: string;
  };
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'text-xs px-1.5 py-0.5',
  md: 'text-sm px-2 py-1',
  lg: 'text-base px-3 py-1.5',
};

const iconSizes = {
  sm: 12,
  md: 14,
  lg: 16,
};

export function CategoryBadge({
  category,
  showLabel = true,
  size = 'md',
  className,
}: CategoryBadgeProps) {
  return (
    <Badge
      className={cn(
        'flex items-center gap-1 font-medium text-white',
        sizeClasses[size],
        className
      )}
      style={{ backgroundColor: category.color }}
    >
      <CategoryIcon iconName={category.icon} size={iconSizes[size]} />
      {showLabel && <span>{category.displayName}</span>}
    </Badge>
  );
}

export default CategoryBadge;
